<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Point Management
            </template>
            <template v-slot:pageDetail>
                Manipulation
            </template>
        </o-bread-crumb>

        <FeatureGate featureKey="point_control">


        <div v-if="thisComponentShow" class="card text-center bg-white shadow-none">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <h4 class="header-title">
                                <i class="fas fa-exchange-alt me-2 primary-icon"></i>Point Manipulation
                            </h4>
                        </div>
                        <p class="header-subtitle me-4 mt-1">Member Points Adjustment Management from Admin</p>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="spinner d-flex justify-content-center align-items-center" v-if='page.isLoading'>
                    <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div class="d-flex flex-column justify-content-center text-primary align-items-center spinner-position" v-if="isExporting">
                    <div class="spinner-border text-primary" role="status"></div>
                    <span class="mt-2 text-primary exporting-animation">Exporting...</span>
                </div>

                <div class="" v-if="page.output">
                    <div class="filter-action-wrapper mb-4 mt-3">
                        <div class="filter-controls">
                            <!-- Search Control -->
                            <div class="search-box-custom">
                                <div class="search-type-tabs">
                                    <button 
                                        v-for="opt in searchOptions" 
                                        :key="opt.value"
                                        class="tab-btn" 
                                        :class="{ active: searchSelected === opt.value }"
                                        @click="searchSelected = opt.value"
                                    >
                                        {{ opt.text }}
                                    </button>
                                </div>
                                <!-- Text Search Input -->
                                <div class="search-input-wrapper" v-show="searchSelected && searchSelected !== 'merchant'">
                                    <input 
                                        type="text" 
                                        class="form-control-search" 
                                        v-model="searchCriteria" 
                                        placeholder="Search..." 
                                        @keyup.enter="doSearch()" 
                                    />
                                    <button v-if="!isSearchActive" class="btn-search" @click="doSearch()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button v-else class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                                <!-- Merchant Filter Dropdown -->
                                <div class="search-input-wrapper" v-show="searchSelected === 'merchant'">
                                    <div class="input-container-search">
                                        <select class="form-select custom-select-transparent" v-model="selectMerchant" @change="doSearch()">
                                            <option v-for="m in merchants" :key="m.value" :value="m.value">
                                                {{ m.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <button v-if="isSearchActive" class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="action-section">
                            <div class="action-buttons-group">
                                <button class="btn btn-refresh" @click.prevent="resetState()" title="Refresh">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                                <button class="btn btn-action-secondary" @click.prevent="downloadState()" title="Export">
                                    <i class="fas fa-file-export me-1"></i> Export
                                </button>
                                <button v-if="hasTransactionWrite && hasVoucherRedeemWrite" class="btn btn-add" @click="showModalDuration">
                                    <i class="fas fa-plus me-1"></i> Create Inject Point
                                </button>
                            </div>
                        </div>
                    </div>

                    <o-table style="text-align:left;" class="table-hover point-manipulation-table">
                        <thead>
                            <tr>
                                <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in injectPointMembers" :key="index">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                                <td>
                                    <span v-if="item.member">{{ formatMemberName(item.member) }}</span>
                                    <span v-else style="color: red;">Not Found</span>
                                </td> 
                                <td>
                                    <span v-if="item.merchant">{{ item.merchant.name }}</span>
                                    <span v-else-if="selectedBusinessProfile.merchant_id == null">{{ corporateName }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>{{ formatStatusPoint(item.transaction_id,item.point) }}</td>
                                <td>{{ formatStatus(item.transaction_id) }}</td>
                                <td class="ml-3">
                                    <div class="d-flex gap-2">
                                        <div v-if=" (isRoot && item.member) || (isRoot == false && item.member && write && canEditOrDelete(item) && hasTransactionWrite == true && hasVoucherRedeemWrite == true)">
                                            <button
                                                @click="editModalDuration(item, item.id, item.member.id, formatMemberName(item.member), item.point, item.status, item.description)"
                                                class="btn btn-action btn-edit"
                                            >
                                                <i class="fas fa-edit me-1"></i> Edit
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="injectPointMembers.length === 0">
                                <td colspan="6" class="text-center">No records found</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>

            <!-- Summary Cards -->
            <div class="total-summary mt-4 mb-3">
                <div class="row g-3">
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon summary-icon-total">
                                    <i class="fas fa-exchange-alt"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Total Manipulations</p>
                                    <h3 class="summary-value">{{ totalManipulations }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon summary-icon-topup">
                                    <i class="fas fa-arrow-up"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Total Top Up Points</p>
                                    <h3 class="summary-value text-success">+ {{ totalTopUpPoints }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="summary-card">
                            <div class="summary-content">
                                <div class="summary-icon summary-icon-deduction">
                                    <i class="fas fa-arrow-down"></i>
                                </div>
                                <div class="summary-details">
                                    <p class="summary-label">Total Deduction Points</p>
                                    <h3 class="summary-value text-danger">- {{ totalDeductionPoints }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        </FeatureGate>
    </div>
    <br>
    <inject-point-form
        v-if="isModalVisibleDuration"
        @parentAddItem="saveDetailDuration"
        @parentCloseModal="closeModalDuration"
        :editedItemDuration="editedItemDuration"
        :pointplans="pointplans"
        :allowGenerateCalculate="allowGenerateCalculate" >
    </inject-point-form>
</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb} from '@/components/OmnihControl'
import FeatureGate from '@/components/upsell/FeatureGate.vue';
import { computed, onMounted, onBeforeUnmount, reactive, ref, watch } from 'vue'
import InjectPointForm from './InjectPointForm.vue';
import { usePointSystem } from '@/composables/pointsystem'
import { useToast } from '@/composables/useToast'

export default {
    setup() {
        const { isPointSystemActive, showCorporateInjectPoint, showCorporatePointPlan } = usePointSystem()
        const { showToast } = useToast()
        const selectedBusinessProfile = reactive({
            corporate_id: null,
            branch_id: null,
            merchant_id: null
        })

        let meta = computed(() => store.state.injectPointMember.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'point-manipulation'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        const fields = computed(() => {
            if (selectedBusinessProfile.merchant_id == null) {
                return [
                    'No',
                    'Member Name',
                    'Corporate/Merchant',
                    'Point',
                    'Status',
                    'Action'
                ];
            }
            return [
                'No',
                'Member Name',
                'Merchant',
                'Point',
                'Status',
                'Action'
            ];
        });

        const merchants = ref([]);

        const selectMerchant = ref();

        const pointplanSearch = ref([]);

        const selectPointplan = ref();



        const error = ref(null);
        const editedItemDuration = ref({
            corporate_id: '',
            expiration: 0 
        });

        const isModalVisibleDuration = ref(false);

        const searchOptions = computed(() => {
            const options = [
                { value: 'member_name', text: 'Member Name' }
            ];
            if (selectedBusinessProfile.merchant_id == null) {
                options.push({ value: 'merchant', text: 'Merchant' });
            }
            return options;
        });

        const thisComponentShow = ref(true);
        const hasTransactionWrite = ref(true);
        const hasVoucherRedeemWrite = ref(true);
        const isRoot = ref(false);
        const isExporting = ref(false);

        const downloadState = async () => {
            isExporting.value = true;

            try {
                const response = await store.dispatch('injectPointMember/export');
                await handleDownloadResponse(response);
                showToast({
                    type: 'success',
                    title: 'Export Success',
                    message: 'Data exported successfully'
                });
            } catch (err) {
                console.error(err);
                showToast({
                    type: 'error',
                    title: 'Export Failed',
                    message: 'Failed to export data'
                });
            } finally {
                isExporting.value = false;
            }
        };

        const handleDownloadResponse = async (response) => {
            const fileUrl = response.data.data;
            const fileName = fileUrl.split('/').pop();

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }
        });

        onBeforeUnmount(() => {
            // Reset pagination state when leaving this module
            store.commit('injectPointMember/reset_meta');
        });

        function showModalDuration() {
            editedItemDuration.value = {};
            isModalVisibleDuration.value = true;
        }

        function closeModalDuration() {
           isModalVisibleDuration.value = false;
        }

        function editModalDuration(item, id, member_id, member_name, point, status,description ) {
            editedItemDuration.value = {
                data: item,
                id: id, 
                member_id: member_id,
                member_name: member_name,
                point: point, 
                status: status,
                description: description
            };
            isModalVisibleDuration.value = true;
        }

        function load_state(){
            page.isLoading = true;

            store.dispatch('injectPointMember/read')
            .then(() => {
                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                    isRoot.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;

                        const transactionModule = userModules.find(module => module.module_name === 'transaction');
                        const voucherRedeemModule = userModules.find(module => module.module_name === 'voucher_redeem');

                        hasTransactionWrite.value = transactionModule ? transactionModule.write === 1 : false;
                        hasVoucherRedeemWrite.value = voucherRedeemModule ? voucherRedeemModule.write === 1 : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            }).catch((err) => {
                showToast({
                    type: 'error',
                    title: 'Load Failed',
                    message: err.response?.data?.error ?? err.response?.data?.message ?? 'Failed to load data'
                });
                console.error(err);
            })
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });
        }

        function destroy(id) {

            page.isLoading = true;
            
            setTimeout(() => {
                page.isLoading = false;
            }, 5000);

            if(confirm("Do you really want to delete ?")){
            
                store.dispatch('injectPointMember/delete',id)
                .then(() => {
                    store.dispatch('injectPointMember/read')
                    .then(function(){
                        })
                    .catch((err) => console.error(err));
                }).catch((err) => {
                    showToast({
                        type: 'error',
                        title: 'Delete Failed',
                        message: err.response?.data?.error ?? 'Failed to delete point manipulation'
                    });
                }).finally(() => {
                    page.isLoading = false;
                });
            }else{
                page.isLoading = false;
            }
        }

        function canEditOrDelete(item) {
            const userLevel = store.state.Auth.currUser.level;
            const userMerchantId = store.state.Auth.selectedBusinessProfile.merchant_id;

            if (userLevel === 'root' || userLevel === 'corporate') {
                return true;
            } else if (!item.merchant || !item.merchant.name || item.merchant.name === '-') {
                return false;
            } else if (userLevel === 'merchant' || userLevel === 'branch') {
                const canEdit = userMerchantId && item.merchant && item.merchant.id === userMerchantId;
                return canEdit;
            } else {
                return false;
            }
        }
        function saveDetailDuration(dataDariChild) {
            page.isLoading = true;

            store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                dataDariChild.corporate_id = businessProfile.corporate_id;
                if (businessProfile.merchant_id != null) {
                    dataDariChild.merchant_id = businessProfile.merchant_id;
                }

                if (dataDariChild.title === 'Edit Member Inject Point') {
                    store.dispatch('injectPointMember/update', { data: dataDariChild })
                        .then((response) => { 
                            if (response.data.message === 'INJECT_POINT_MEMBER.UPDATE_BY_ID.SUCCESS') {
                                showToast({
                                    type: 'success',
                                    title: 'Updated',
                                    message: 'Point manipulation updated successfully'
                                });
                            }
                            load_state();
                        })
                        .catch((err) => {
                            showToast({
                                type: 'error',
                                title: 'Update Failed',
                                message: err.response?.data?.error ?? 'Failed to update point manipulation'
                            });
                        })
                        .finally(() => {
                            page.isLoading = false;
                            isModalVisibleDuration.value = false;
                        });
                } else {
                    store.dispatch('injectPointMember/create', { data: dataDariChild })
                        .then((response) => { 
                            if (response.data.message === 'INJECT_POINT_MEMBER.CREATE.SUCCESS') {
                                showToast({
                                    type: 'success',
                                    title: 'Created',
                                    message: 'Point manipulation created successfully'
                                });
                            }
                            load_state();
                        })
                        .catch((err) => {
                            showToast({
                                type: 'error',
                                title: 'Create Failed',
                                message: err.response?.data?.error ?? 'Failed to create point manipulation'
                            });
                        })
                        .finally(() => {
                            page.isLoading = false;
                            isModalVisibleDuration.value = false;
                        });
                }
            }).catch((err) => {
                showToast({
                    type: 'error',
                    title: 'Error',
                    message: 'Error fetching business profile: ' + err.message
                });
                page.isLoading = false;
                isModalVisibleDuration.value = false;
            });
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            console.log({page});
            console.log({_meta});
            store.commit('injectPointMember/switch_page',{meta:_meta})
            load_state()
        }

        async function loadSelectedBusinessProfile() {
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
                selectedBusinessProfile.branch_id = businessProfile.branch_id;
                selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                selectMerchant.value = businessProfile.merchant_id == null ? "all" : businessProfile.merchant_id;

                if (businessProfile.merchant_id == null) {
                    loadMerchants();
                }
            }).finally(() => {
                load_state();
                loadPointPlans();
            });
        }

        function loadPointPlans() {
            store.commit('Pointplan/clear_filter');
            let filter = {};
            
            if (showCorporatePointPlan.value) {
                // Centralize mode
                filter = { corporate_id: selectedBusinessProfile.corporate_id };
                store.commit('Pointplan/add_filter', {filter});
            } else {
                // decentralize mode
                if (selectedBusinessProfile.merchant_id) {
                    filter = { merchant_id: selectedBusinessProfile.merchant_id };
                } else if (selectMerchant.value && selectMerchant.value !== 'all') {
                    filter = { merchant_id: selectMerchant.value };
                } else if (selectedBusinessProfile.branch_id) {
                    filter = { branch_id: selectedBusinessProfile.branch_id };
                }
                store.commit('Pointplan/add_filter', {filter});
            }

            store.dispatch('Pointplan/read').catch(err => console.error('Failed to fetch point plans', err));
        }

        function loadMerchants() {
            store.dispatch('Merchant/read_all_corporate', selectedBusinessProfile.corporate_id).then((merchantList) => {
                merchants.value = [
                    {value: "all", text: "From all merchant"}, 
                    ...merchantList.map((merch) => ({
                        'value': merch.id, 
                        'text': merch.name
                    }))
                ];
            }).catch(err => console.error('Failed to load merchants', err));
        }

        const searchSelected = ref('member_name');
        const searchCriteria = ref('');
        const isSearchActive = ref(false);

        function doSearch() {
            if (!searchSelected.value) return;

            // Handle merchant filter via tab
            if (searchSelected.value === 'merchant') {
                isSearchActive.value = true;
                // selectMerchant watcher handles the actual filtering
                return;
            }

            let search = {};
            if (searchCriteria.value) {
                search[searchSelected.value] = searchCriteria.value;
            } else {
                return;
            }

            isSearchActive.value = true;
            
            if (meta.value.page !== 1) {
                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('injectPointMember/switch_page', { meta: updatedMeta });
            }

            store.commit('injectPointMember/set_search', { search });
            store.dispatch('injectPointMember/read').then(() => {});
        }

        function clearSearch() {
            isSearchActive.value = false;
            searchCriteria.value = '';

            // Reset merchant filter if on merchant tab
            if (searchSelected.value === 'merchant' && selectedBusinessProfile.merchant_id == null) {
                selectMerchant.value = 'all';
                const filter = { corporate_id: selectedBusinessProfile.corporate_id };
                store.commit('injectPointMember/add_filter', { filter });
            }

            store.commit('injectPointMember/clear_search');
            store.dispatch('injectPointMember/read').then(() => {});
        }

        function resetState() {
            searchSelected.value = 'member_name';
            searchCriteria.value = '';
            isSearchActive.value = false;

            // Reset merchant filter for corporate dashboard
            if (selectedBusinessProfile.merchant_id == null) {
                selectMerchant.value = 'all';
                const filter = { corporate_id: selectedBusinessProfile.corporate_id };
                store.commit('injectPointMember/add_filter', { filter });
            }

            store.commit('injectPointMember/clear_search');
            const updatedMeta = { ...meta.value, page: 1 };
            store.commit('injectPointMember/switch_page', { meta: updatedMeta });
            load_state();
        }

        function formatMemberName(member) {
            return `${member.title} ${member.first_name} ${member.last_name}`; // Menggabungkan nama lengkap
        }

        function formatStatus(transaction_id) {
            return transaction_id ? 'Top Up Point' : 'Deduction Point';
        }

        function formatStatusPoint(transaction_id, point) {
            return transaction_id ? `${point}` : `- ${point}`;
        }

        watch(
            () => selectMerchant.value,
            (newVal) => {
                const filter = newVal == "all" 
                    ? { corporate_id: selectedBusinessProfile.corporate_id } 
                    : { merchant_id: newVal, corporate_id: selectedBusinessProfile.corporate_id }

                store.commit('injectPointMember/add_filter', {filter});
                store.dispatch('injectPointMember/read')
                .then()
                .catch((err) => {
                    showToast({
                        type: 'error',
                        title: 'Error',
                        message: err.response?.data?.error ?? 'Failed to load data'
                    });
                    thisComponentShow.value = false;
                    console.error(err);
                })
                .finally(() => {
                    page.output = true;
                    loadPointPlans();
                });
            }
        )

        return {
            page,
            destroy,
            fields,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            pointplanSearch,
            selectPointplan,
            searchOptions,
            searchSelected,
            searchCriteria,
            isSearchActive,
            doSearch,
            clearSearch,
            resetState,
            thisComponentShow,
            write,
            selfLoaded,
            showModalDuration,
            editedItemDuration,
            isModalVisibleDuration,
            closeModalDuration,
            editModalDuration,
            saveDetailDuration,
            error,
            formatMemberName,
            formatStatus,
            canEditOrDelete,
            hasTransactionWrite,
            hasVoucherRedeemWrite,
            isRoot,
            downloadState,
            isExporting,
            isPointSystemActive,
            formatStatusPoint,
            showCorporateInjectPoint,
            // Show Permission Denied with flag
            shouldShowPermissionDenied: computed(() => {
                return false;
            }),
            allowGenerateCalculate: computed(() => {
                // If it's a corporate user (merchant_id is null) AND the point system is Decentralize
                if (selectedBusinessProfile.merchant_id == null && !showCorporatePointPlan.value) {
                    if (selectMerchant.value && selectMerchant.value !== 'all') {
                        return true;
                    }
                    return false;
                }
                return true;
            }),
            corporateName: computed(() => {
                // Use the same source as navbar-desktop.vue
                const selectedProfile = localStorage.getItem('selected_business_profile');
                if (selectedProfile) {
                    try {
                        const parsed = JSON.parse(selectedProfile);
                        if (parsed.corporate_name) {
                            return parsed.corporate_name;
                        }
                    } catch (e) {
                        // fallback below
                    }
                }
                // Fallback to store business profiles
                const profiles = store.state.Auth.businessProfiles;
                if (profiles && profiles.corporate && profiles.corporate.length > 0) {
                    return profiles.corporate[0].name;
                }
                return '-';
            }),
            totalManipulations: computed(() => {
                return store.state.injectPointMember.summary.total_records || 0;
            }),
            totalTopUpPoints: computed(() => {
                return store.state.injectPointMember.summary.total_top_up_points || 0;
            }),
            totalDeductionPoints: computed(() => {
                return store.state.injectPointMember.summary.total_deduction_points || 0;
            })
        }
    },
    computed: {
        ... mapState({
            injectPointMembers: state => state.injectPointMember.injectPointMembers,
        }),
        pointplans() {
            return this.$store.state.Pointplan.pointplans || [];
        }
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        FeatureGate,
        InjectPointForm
    }
}
</script>

<style scoped>
/* Summary Cards */
.total-summary {
    padding: 0 10px;
}

.summary-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    height: 100%;
}

.summary-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.summary-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    flex-shrink: 0;
}

.summary-icon-total {
    background-color: var(--primary-color, #fc6666);
}

.summary-icon-topup {
    background-color: #198754;
}

.summary-icon-deduction {
    background-color: #dc3545;
}

.summary-details {
    flex: 1;
    min-width: 0;
}

.summary-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin: 0 0 2px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.summary-value {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    line-height: 1.2;
    color: #212529;
}

/* Filter and Action Bar Styling */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

/* Custom Search Box */
.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: max-content;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
    flex-wrap: wrap;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color, #fc6666);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s;
    overflow: hidden;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color, #fc6666);
    box-shadow: 0 0 0 2px rgba(252, 102, 102, 0.1);
}

.search-input-wrapper input {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
}

.search-input-wrapper select.custom-select-transparent {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
    cursor: pointer;
    min-width: 180px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 12px;
    padding-right: 32px;
}

.search-input-wrapper select.custom-select-transparent:focus {
    box-shadow: none;
    border: none;
}

.input-container-search {
    position: relative;
    width: 100%;
    flex: 1;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.btn-search:hover {
    background: #e2e8f0;
    color: var(--primary-color, #fc6666);
}

.search-input-wrapper .btn-search {
    position: relative;
    width: 44px;
    height: 42px;
    border-radius: 0;
    background: transparent;
}

.search-input-wrapper .btn-search:hover {
    background: #f1f5f9;
}

.search-input-wrapper .btn-search::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1.1px;
    height: 60%;
    background: linear-gradient(to bottom, rgba(203, 213, 225, 0), rgba(203, 213, 225, 1), rgba(203, 213, 225, 0));
    pointer-events: none;
}

/* Action Buttons */
.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 8px;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-action-secondary {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
    cursor: pointer;
}

.btn-action-secondary:hover {
    background-color: #e2e8f0;
    color: #1e293b;
}

.btn-add {
    background-color: var(--primary-color, #fc6666);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

/* Table Styles */
.point-manipulation-table {
    white-space: nowrap;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.point-manipulation-table th,
.point-manipulation-table td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

/* Action Buttons in Table */
.btn-action {
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
}

.btn-edit {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-edit:hover {
    background-color: #e5e7eb;
    color: #111827;
}

/* Header */
.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    text-align: left;
}

/* Spinner Overlay */
.spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 200;
}
</style>